import { call, put } from 'redux-saga/effects';
import { AUTH_PUBLISHER_CLAIM, AUTH_USER_CLAIM } from '@piconetworks/pkg-endpoints';
import { picoAPIHelper } from '@piconetworks/pkg-network-middleware';

function exchangeClaim(_ref) {
  var types = _ref.types,
    claim = _ref.claim,
    scope = _ref.scope,
    publisherId = _ref.publisherId,
    team = _ref.team;
  return function* () {
    try {
      var isPublisherScope = scope === 'publisher';
      var pathname = isPublisherScope ? AUTH_PUBLISHER_CLAIM() : AUTH_USER_CLAIM();
      var url = pathname;
      if (!isPublisherScope) {
        url += "/" + claim;
      }
      if (team) {
        url += team ? "/" + team : '';
      }
      var _yield$call = yield call(picoAPIHelper, {
          url: url,
          method: 'get',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            publisherid: publisherId
          }
        }),
        data = _yield$call.data;
      if (data) {
        yield put({
          type: types.EXCHANGE_CLAIM_SUCCESS,
          payload: data
        });
      } else {
        throw new Error('unable to fetch article');
      }
    } catch (error) {
      yield put({
        type: types.EXCHANGE_CLAIM_ERROR,
        error: (error === null || error === void 0 ? void 0 : error.message) || 'GET_ARTICLE_ERROR'
      });
    }
  }();
}

export { exchangeClaim as default };
//# sourceMappingURL=exchangeClaim.js.map
